<template>
    <div :class="{
        'col-md-9': question_has_image,
        'col-md-12': !question_has_image,
    }">
        <div class="card" style="border-radius: 13px">
            <div class="card-header border-0 pt-1">
                <h3 class="card-title align-items-start flex-column">
                    <span class="card-label fw-bolder fs-3 mb-1">{{ sequence }}: {{ questionLabel }}</span>
                    <span class="text-muted fw-bold fs-7">{{
                        moduleName
                        }}</span>
                </h3>
            </div>

            <div class="card-body pt-0 pr-0 pl-0 pb-0">
                <div class="col-md-12">
                    <div class="table-responsive border-0">
                        <table class="table align-middle gs-0">
                            <tbody>
                                <tr v-for="option in props.questionOptions" :key="option.id">
                                    <td width="1%" class="d-flex">
                                        <span class="bullet bullet-vertical h-40px bg-primary"></span>
                                        <div class="form-check form-check-custom form-check-solid mx-2">
                                            <input class="option_question form-check-input" :value="option.id"
                                                v-model="value" style="top: 40%" type="radio" />
                                        </div>
                                    </td>
                                    <td width="99%" class="m-0 p-0">
                                        <label style="
												cursor: pointer;
												font-size: 16px;
											" @click="value = option.id" class="d-block pt-3 pb-3 font-weight-bold">
                                            {{ option.label }}
                                            <span class="text-success" v-if="
                                                showCorrectOption &&
                                                option.right_answer
                                            ">[ OPÇÃO CORRETA ]</span>
                                        </label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-1 text-center">
                <button id="previous" :disabled="disabledButton.previous" class="btn btn-secondary w-100 mb-2 p-4"
                    @click="buttonsAction('previous')">
                    <span class="fa fa-lg fa-arrow-left"></span>
                </button>
            </div>
            <div class="col-md-1 text-center">
                <button id="next" :disabled="disabledButton.next" class="btn btn-secondary w-100 mb-2 p-4"
                    @click="buttonsAction('next')">
                    <span class="fa fa-lg fa-arrow-right"></span>
                </button>
            </div>

            <div class="col-md-5">
                <button id="validate" :disabled="value === null || value === 0 || loading"
                    style="margin-top: 0px; height: inherit" class="btn w-100 fs-3 test_submit_btn validate_question"
                    @click="checkAnswer()">
                    <div v-if="loading">
                        <i class="fa-solid fa-spinner fa-spin" style="color: #ffffff"></i>
                        Enviando resposta
                    </div>
                    <div v-else>
                        <span class="fa fa-lg text-white fa-check-circle"></span>
                        Confirmar resposta
                    </div>
                </button>
            </div>
            <div class="col">
                <div class="alert alert-warning mb-0">
                    <b> <i class="fa text-warning fa-warning"></i> Atenção! </b>
                    A questão é computada ao clicar no botão "Confirmar
                    resposta"
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-3" v-if="question_has_image">
        <div class="card" style="border-radius: 13px">
            <div class="card-body pt-0 pr-0 pl-0 pb-0">
                <div style="font-size: 22px">
                    <div class="text-center">
                        <img style="max-height: 300px; max-height: 300px" class="img-fluid m-1"
                            :src="question_image_url" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {
    computed,
    onMounted,
    Ref,
    ref,
    PropType,
    watch,
    inject,
} from 'vue';
import { usePage, router } from '@inertiajs/vue3';
import { TestQuestion } from 'resources/js/Interfaces/TestQuestion';
import { ActiveQuestion } from 'resources/js/Interfaces/ActiveQuestion';
import { QuestionOption } from 'resources/js/Interfaces/QuestionOption';
import axios from 'axios';
// import Swal from 'sweetalert2/dist/sweetalert2.js'
import { commonStore } from '../../stores/common';

const props = defineProps({
    activeQuestion: {
        type: Object as PropType<ActiveQuestion>,
        required: true,
    },
    showCorrectOption: { type: Boolean, required: true },
    questionOptions: { type: Array<QuestionOption>, required: true },
    questionsInfo: { type: Array<TestQuestion>, required: true },
});

interface disabledButton {
    next: boolean;
    previous: boolean;
}

const sequence = props.activeQuestion['sequence'];
const questionLabel = props.activeQuestion.testQuestion.question.label;
const moduleName = props.activeQuestion['moduleName'];
const question: Object = ref({});
const optionChecked: Ref<number> = ref(0);
const currentQuestion: Ref<ActiveQuestion> = ref(props.activeQuestion);
const disabledButton: Ref<disabledButton> = ref({
    next: false,
    previous: false,
});
const emitter: any = inject('emitter');
const common = commonStore();

const value = computed({
    get() {
        return common.get_option_checked;
    },
    set(value) {
        return common.set_option_checked(value);
    },
});

const question_has_image = props.activeQuestion.testQuestion.question
    .presentation_img
    ? true
    : false;
const question_image_url = props.activeQuestion.testQuestion.question.presentation_img;

const loading = ref(false);

onMounted(() => {
    disabledButton.value = {
        next: false,
        previous: false,
    };
    const lengthQuestionInfo = props.questionsInfo.length - 1;
    if (
        currentQuestion.value.testQuestion.id === props.questionsInfo[0].id
    ) {
        disabledButton.value.previous = true;
    }
    if (
        currentQuestion.value.testQuestion.id ===
        props.questionsInfo[lengthQuestionInfo].id
    ) {
        disabledButton.value.next = true;
    }
    document.addEventListener('keyup', common.key_Up);
    common.set_question_options(props.questionOptions);
    common.set_option_checked(
        props.activeQuestion.testQuestion.selected_question_option_id
    );
});

async function checkAnswer() {
    loading.value = true;
    var url = `/prova/enroll/test-question/${currentQuestion.value.testQuestion.id}/user_answer`;
    await axios
        .post(url, {
            selected_question_option_id: common.get_option_checked,
        })
        .then((response) => {
            emitter.emit('reload_question', { action: 'next' });
        })
        .finally(() => (loading.value = false));
}

function buttonsAction($action) {
    const questionsList = props.questionsInfo;
    var currentQuestionToCompare = 0;
    if ($action === 'next') {
        currentQuestionToCompare =
            currentQuestion.value.testQuestion.sequence + 1;
        emitter.emit('reload_question', { action: 'next' });
    }

    if ($action === 'previous') {
        currentQuestionToCompare =
            currentQuestion.value.testQuestion.sequence - 1;
        emitter.emit('reload_question', { action: 'previous' });
    }
    var question = questionsList.find((question) => {
        return question.sequence === currentQuestionToCompare;
    });
    if (question === undefined) {
        question = questionsList.find((question) => {
            return question.sequence === 1;
        });
    }
}
</script>
<style scoped>
.question_row table td {
    padding: 0.5rem;
}

.test_submit_btn {
    color: white;
    background: #fa6735 !important;
}

.test_submit_btn:hover {
    color: white;
    background: #ee4b15 !important;
}

.question_row .input-selection {
    line-height: 45px;
    --bs-gutter-x: 1.5rem !important;
}

.row {
    --bs-gutter-x: 1.5rem !important;
}

label {
    font-weight: bold;
}
</style>
